import { z } from 'zod';
export const createChannelSchema = z.object({
    name: z
        .string()
        .min(1, 'Channel name is required')
        .max(80, 'Channel name must be at most 80 characters')
        .trim(),
    type: z.enum(['PRIVATE']).default('PRIVATE'),
    topic: z.string().max(250, 'Topic must be at most 250 characters').optional(),
    // The creator's NaCl-sealed copy of the freshly-generated channel key.
    // When supplied, the API stores it as the creator's `ChannelMemberKey`
    // for the channel's auto-created epoch 1 and transitions that epoch to
    // ACTIVE. When omitted, epoch 1 is left in DISTRIBUTING so the caller
    // can finish distribution via POST /channels/:id/keys/epochs/:epoch.
    initialEncryptedChannelKey: z.string().min(1).optional(),
});
export const updateChannelSchema = z.object({
    name: z.string().min(1).max(80).trim().optional(),
    topic: z.string().max(250).optional(),
});
export const createDmSchema = z.object({
    targetUserId: z.string().uuid('Invalid user ID'),
});
/** Body for POST /channels/:channelId/members — the user to add. */
export const addChannelMemberSchema = z.object({
    userId: z.string().uuid('Invalid user ID'),
});
//# sourceMappingURL=channel.schema.js.map